<template>
  <div class="home">
    <Login />
  </div>
</template>

<script>
import Login from "../components/Login"

export default {
  components: {
		Login
	}
}
</script>